import { apiFetch, buildApiError } from './httpClient';

async function http(path, { headers: extraHeaders, ...rest } = {}) {
  const resp = await apiFetch(path, {
    ...rest,
    headers: { 'Content-Type': 'application/json', ...extraHeaders },
  });
  if (!resp.ok) {
    throw await buildApiError(resp, 'Billing request failed');
  }
  if (resp.status === 204) return null;
  return resp.json();
}

export const billingService = {
  // GET /api/billing/plans
  async getPlans() {
    return http('/api/billing/plans');
  },

  // GET /api/billing/status
  async getBillingStatus() {
    return http('/api/billing/status');
  },

  // GET /api/billing/payment-methods
  async getPaymentMethods() {
    return http('/api/billing/payment-methods');
  },

  // POST /api/billing/payment-methods
  async addPaymentMethod(stripePaymentMethodId) {
    return http('/api/billing/payment-methods', {
      method: 'POST',
      body: JSON.stringify({ stripe_payment_method_id: stripePaymentMethodId }),
    });
  },

  // POST /api/billing/subscriptions
  async createSubscription(planTier, stripePaymentMethodId) {
    return http('/api/billing/subscriptions', {
      method: 'POST',
      body: JSON.stringify({
        plan_tier: planTier,
        stripe_payment_method_id: stripePaymentMethodId,
      }),
    });
  },

  // PATCH /api/billing/subscriptions
  async updateSubscription(planTier) {
    return http('/api/billing/subscriptions', {
      method: 'PATCH',
      body: JSON.stringify({ plan_tier: planTier }),
    });
  },

  // DELETE /api/billing/subscriptions
  async cancelSubscription() {
    return http('/api/billing/subscriptions', {
      method: 'DELETE',
      body: JSON.stringify({}),
    });
  },

  // GET /api/billing/usage
  async getUsage() {
    return http('/api/billing/usage');
  },

  // GET /api/billing/invoices
  async getInvoices(limit = 20, offset = 0) {
    return http(`/api/billing/invoices?limit=${limit}&offset=${offset}`);
  },
};
